export const mobileFilters = [
  {
    id: 'householdIncome',
    displayName: 'Household Income',
    options: [
      { value: '$50k-$74,999', label: '$50k-$74,999' },
      { value: '$40k-$49,999', label: '$40k-$49,999' },
      { value: '$20k-$39,999', label: '$20k-$39,999' },
      { value: '$75k-$99,999', label: '$75k-$99,999' },
      { value: '$0-$20K', label: '$0-$20K' },
      { value: '$100k-$149,999', label: '$100k-$149,999' },
      { value: '$150k+', label: '$150k+' }
    ]
  },
  {
    id: 'generation',
    displayName: 'Generation',
    options: [
      { value: 'Generation X', label: 'Generation X' },
      { value: 'Generation Y', label: 'Generation Y' },
      { value: 'Generation Z', label: 'Generation Z' },
      { value: 'White collars', label: 'White collars' },
      { value: 'Millennials', label: 'Millennials' }
    ]
  },
  {
    id: 'purchaseIntent',
    displayName: 'Purchase Intent',
    options: [
      { value: 'Animals & Pet', label: 'Animals & Pet' },
      { value: 'Apparel & Accessories', label: 'Apparel & Accessories' },
      { value: 'Automotive', label: 'Automotive' },
      { value: 'Baby & Toddler', label: 'Baby & Toddler' },
      { value: 'Bargain Hunters', label: 'Bargain Hunters' },
      { value: 'E-commerce', label: 'E-commerce' },
      { value: 'E-Learing & Online courses', label: 'E-Learing & Online courses' },
      { value: 'Education', label: 'Education' },
      { value: 'Electronics', label: 'Electronics' },
      { value: 'Accounting & Finance Jobs', label: 'Accounting & Finance Jobs' },
      { value: 'Career Consulting Services', label: 'Career Consulting Services' },
      { value: 'Clerical & Administrative Jobs', label: 'Clerical & Administrative Jobs' },
      { value: 'Education Jobs', label: 'Education Jobs' },
      { value: 'Executive & Management Jobs', label: 'Executive & Management Jobs' },
      { value: 'Government & Public Sector Jobs', label: 'Government & Public Sector Jobs' },
      { value: 'Health & Medical Jobs', label: 'Health & Medical Jobs' },
      { value: 'Internships', label: 'Internships' },
      { value: 'IT & Technical Jobs', label: 'IT & Technical Jobs' },
      { value: 'Legal Jobs', label: 'Legal Jobs' },
      { value: 'Resumes & Portfolios', label: 'Resumes & Portfolios' },
      { value: 'Retail Jobs', label: 'Retail Jobs' },
      { value: 'Sales & Marketing Jobs', label: 'Sales & Marketing Jobs' },
      { value: 'Buying products for Pre-school kids', label: 'Buying products for Pre-school kids' },
      { value: 'Buying products for Pre-Teens', label: 'Buying products for Pre-Teens' },
      { value: 'Buying products for Teens', label: 'Buying products for Teens' },
      { value: 'Buying products for Toddlers', label: 'Buying products for Toddlers' },
      { value: 'Fashion', label: 'Fashion' },
      { value: 'Finance', label: 'Finance' },
      { value: 'German Banks', label: 'German Banks' },
      { value: 'Clothing & Jewellery', label: 'Clothing & Jewellery' },
      { value: 'Consumer Electronics', label: 'Consumer Electronics' },
      { value: 'Home Improvement', label: 'Home Improvement' },
      { value: 'Health & Beauty', label: 'Health & Beauty' },
      { value: 'Collecting', label: 'Collecting' },
      { value: 'Craft', label: 'Craft' },
      { value: 'Musical Instruments', label: 'Musical Instruments' },
      { value: 'Hobbies & Interets', label: 'Hobbies & Interets' },
      { value: 'Home & Garden', label: 'Home & Garden' },
      { value: 'Life Stage', label: 'Life Stage' },
      { value: 'Luxurious Brands', label: 'Luxurious Brands' },
      { value: 'Luxury Homes', label: 'Luxury Homes' },
      { value: 'Media > Books', label: 'Media > Books' },
      { value: 'Media > DVDs & Videos', label: 'Media > DVDs & Videos' },
      { value: 'Media > Music', label: 'Media > Music' },
      { value: "Men's Fashion", label: "Men's Fashion" },
      { value: 'Online grocery shopping', label: 'Online grocery shopping' },
      { value: 'Online Shoppers', label: 'Online Shoppers' },
      { value: 'Pets', label: 'Pets' },
      { value: 'Real Estate', label: 'Real Estate' },
      { value: 'Video Game Software', label: 'Video Game Software' },
      { value: 'Exercise & Fitness', label: 'Exercise & Fitness' },
      { value: 'Technology & Computing', label: 'Technology & Computing' },
      { value: 'Games', label: 'Games' },
      { value: 'Toys', label: 'Toys' },
      { value: 'Travel', label: 'Travel' },
      { value: 'Video conference tools', label: 'Video conference tools' },
      { value: "Women's Fashion", label: "Women's Fashion" }
    ]
  },
  {
    id: 'age',
    displayName: 'Age',
    options: [
      { value: '18-24', label: '18-24' },
      { value: '25-34', label: '25-34' },
      { value: '35-44', label: '35-44' },
      { value: '45-54', label: '45-54' },
      { value: '55+', label: '55+' }
    ]
  },
  {
    id: 'interest',
    displayName: 'Interest',
    options: [
      { value: 'Sports', label: 'Sports' },
      { value: 'Shopping', label: 'Shopping' },
      { value: 'Movies', label: 'Movies' },
      { value: 'Education', label: 'Education' },
      { value: 'News', label: 'News' },
      { value: 'Health & Fitness', label: 'Health & Fitness' },
      { value: 'Television', label: 'Television' },
      { value: 'Travel', label: 'Travel' },
      { value: 'Food & Drink', label: 'Food & Drink' },
      { value: 'Pets', label: 'Pets' },
      { value: 'Beauty', label: 'Beauty' },
      { value: 'Books & Literature', label: 'Books & Literature' },
      { value: 'Automotive', label: 'Automotive' },
      { value: 'Entrepreneurs', label: 'Entrepreneurs' },
      { value: 'Arts & Entertainment', label: 'Arts & Entertainment' },
      { value: 'Home & Garden', label: 'Home & Garden' },
      { value: 'Parenting', label: 'Parenting' },
      { value: 'Technology & Computing', label: 'Technology & Computing' },
      { value: 'Business', label: 'Business' },
      { value: 'Personal Finance', label: 'Personal Finance' },
      { value: 'White Collars', label: 'White Collars' },
      { value: 'Style & Fashion', label: 'Style & Fashion' },
      { value: 'Avid Investors', label: 'Avid Investors' },
      { value: 'Lifestyle Choices', label: 'Lifestyle Choices' },
      { value: 'Careers', label: 'Careers' },
      { value: 'Music', label: 'Music' },
      { value: 'Business Software', label: 'Business Software' },
      { value: 'Social', label: 'Social' }
    ]
  }
];
